import {
  CreateBusinessSectionPayload,
  RenameOrMoveBusinessSectionPayload,
  ReorderBusinessSectionsPayload,
  SectionDisplayOrderEntry,
} from "../../../interfaces/BusinessSectionObject";

export function buildCreateSectionPayload(params: {
  businessId: string;
  parentSectionId: string | null;
  name: string;
  displayOrder?: number | null;
}): CreateBusinessSectionPayload {
  return {
    businessId: params.businessId,
    parentSectionId: params.parentSectionId ?? null,
    name: params.name.trim(),
    ...(params.displayOrder != null ? { displayOrder: params.displayOrder } : {}),
  };
}

/**
 * Full replace — always send the section's CURRENT name/parentSectionId for
 * whichever field isn't actually changing (there's no partial-patch option on
 * this endpoint). Callers must pre-fill both from the section being edited.
 */
export function buildRenameOrMoveSectionPayload(params: {
  name: string;
  parentSectionId: string | null;
  displayOrder?: number | null;
}): RenameOrMoveBusinessSectionPayload {
  return {
    name: params.name.trim(),
    parentSectionId: params.parentSectionId ?? null,
    ...(params.displayOrder != null ? { displayOrder: params.displayOrder } : {}),
  };
}

export function buildReorderSectionsPayload(params: {
  businessId: string;
  parentSectionId: string | null;
  orders: SectionDisplayOrderEntry[];
}): ReorderBusinessSectionsPayload {
  return {
    businessId: params.businessId,
    parentSectionId: params.parentSectionId ?? null,
    orders: params.orders,
  };
}
